/* eslint-disable no-undef */

export function trackBlogCTA(button_text, redirect_url) {
  if (window.analytics) {
    window.analytics.track('cta-blog-click', {
      button_text,
    });
  }
  if (redirect_url) window.location.href = redirect_url;
}
